import React, { useState, useEffect } from "react";
import { useHooksGang } from "../../../hooks";
import { map } from "lodash";
import swal from "sweetalert2";

const initialState = {
  gangID: 0,
  gangName: "",
  warehouseID: 0,
  warehouseName: "",
  shippingWarehouseID: 0,
  shippingWarehouseName: "",
  quotationWarehouseID: 0,
  quotationWarehouseName: "",
  serial: "",
  quotationCorrelative: "0",
  ticketCorrelative: "0",
  billCorrelative: "0",
  invoiceCorrelative: "0",
  isEnabled: false,
};

const inputClass = "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
const labelClass = "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

export function FragmentAddEditGang({ onRefetch, gang, onClose }) {
  const { addGang, updateGang, warehouses, getWareHouses } = useHooksGang();
  const [itemGang, setItemGang] = useState(initialState);

  useEffect(() => {
    getWareHouses();
  }, []);

  useEffect(() => {
    if (gang.gangID === undefined || gang.gangID === 0) {
      setItemGang(initialState);
    } else {
      setItemGang(gang);
    }
  }, [gang]);

  const handleChange = (e) => {
    const { target } = e;
    const { name, value } = target;
    setItemGang((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeCheckbox = (e) => {
    const { target } = e;
    const { name, checked } = target;
    setItemGang((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (e.target.gangName.value === "") {
      swal.fire({
        icon: "error",
        title: "Ups...",
        text: "Ingrese el nombre del grupo!",
      });
      return false;
    }

    if (
      e.target.warehouseID.value === "" ||
      e.target.warehouseID.value === 0
    ) {
      swal.fire({
        icon: "error",
        title: "Ups...",
        text: "Seleccione el almacén/autoventa",
      });
      return false;
    }

    if (
      e.target.shippingWarehouseID.value === "" ||
      e.target.shippingWarehouseID.value === 0
    ) {
      swal.fire({
        icon: "error",
        title: "Ups...",
        text: "Seleccione el almacén/envío",
      });
      return false;
    }

    try {
      if (gang.gangID === undefined || gang.gangID === 0) {
        await addGang(itemGang);
        swal.fire({
          position: "center",
          icon: "success",
          title: "Grupo registrado correctamente",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        await updateGang(itemGang);
        swal.fire({
          position: "center",
          icon: "success",
          title: "Grupo actualizado correctamente",
          showConfirmButton: false,
          timer: 1500,
        });
      }
      onClose();
      onRefetch();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form id="form-person" onSubmit={handleSubmit}>
      <div className="space-y-4 px-6 py-5">
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label htmlFor="warehouseID" className={labelClass}>
              <i className="fas fa-store mr-2"></i>
              Almacén de Autoventa
            </label>
            <select
              id="warehouseID"
              className={inputClass}
              name="warehouseID"
              value={itemGang.warehouseID}
              onChange={handleChange}
            >
              <option value={0}>Seleccione almacén</option>
              {map(warehouses, (item) => (
                <option
                  key={item.warehouseID}
                  value={item.warehouseID}
                >
                  {item.warehouseName}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="shippingWarehouseID" className={labelClass}>
              <i className="fas fa-truck mr-2"></i>
              Almacén de Envío
            </label>
            <select
              id="shippingWarehouseID"
              className={inputClass}
              name="shippingWarehouseID"
              value={itemGang.shippingWarehouseID}
              onChange={handleChange}
            >
              <option value={0}>Seleccione almacén</option>
              {map(warehouses, (item) => (
                <option
                  key={item.warehouseID}
                  value={item.warehouseID}
                >
                  {item.warehouseName}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="quotationWarehouseID" className={labelClass}>
              <i className="fas fa-file-invoice mr-2"></i>
              Almacén de Preventa
            </label>
            <select
              id="quotationWarehouseID"
              className={inputClass}
              name="quotationWarehouseID"
              value={itemGang.quotationWarehouseID}
              onChange={handleChange}
            >
              <option value={0}>Igual que almacén de autoventa</option>
              {map(warehouses, (item) => (
                <option
                  key={item.warehouseID}
                  value={item.warehouseID}
                >
                  {item.warehouseName}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="gangName" className={labelClass}>
              <i className="fas fa-users mr-2"></i>
              Nombre Grupo
            </label>
            <input
              type="text"
              id="gangName"
              className={inputClass}
              name="gangName"
              maxLength={200}
              value={itemGang.gangName}
              onChange={handleChange}
              placeholder="Ingrese nombre del grupo"
            />
          </div>

          <div>
            <label htmlFor="serial" className={labelClass}>
              <i className="fas fa-barcode mr-2"></i>
              Serie Grupo
            </label>
            <input
              type="text"
              id="serial"
              className={inputClass}
              name="serial"
              maxLength={200}
              value={itemGang.serial}
              onChange={handleChange}
              placeholder="Ingrese serie del grupo"
            />
          </div>
        </div>

        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50 p-4">
          <h6 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4 flex items-center gap-2">
            <i className="fas fa-chart-line mr-2 text-blue-500"></i>
            Promedio mínimo de ventas del mes pasado
            <i className="fas fa-info-circle ml-2 text-gray-400" title="Suma de montos vendidos en operaciones con tarifa / Número de ventas realizadas en el mes anterior."></i>
          </h6>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <span className="text-gray-500 dark:text-gray-400 text-sm font-medium">S/.</span>
            </div>
            <input
              type="number"
              step="0.01"
              className={`${inputClass} pl-9`}
              name="monthlySalesAverage"
              value={itemGang.monthlySalesAverage || 0}
              onFocus={(e) => e.target.select()}
              onChange={handleChange}
              placeholder="0.00"
            />
          </div>
        </div>

        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50 p-4">
          <h6 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4 flex items-center gap-2">
            <i className="fas fa-list-ol mr-2 text-blue-500"></i>
            Correlativos
          </h6>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="quotationCorrelative" className={labelClass}>
                Preventa
              </label>
              <input
                type="number"
                id="quotationCorrelative"
                className={inputClass}
                name="quotationCorrelative"
                value={itemGang.quotationCorrelative}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="ticketCorrelative" className={labelClass}>
                Ticket
              </label>
              <input
                type="number"
                id="ticketCorrelative"
                className={inputClass}
                name="ticketCorrelative"
                value={itemGang.ticketCorrelative}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="billCorrelative" className={labelClass}>
                Boleta
              </label>
              <input
                type="number"
                id="billCorrelative"
                className={inputClass}
                name="billCorrelative"
                value={itemGang.billCorrelative}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="invoiceCorrelative" className={labelClass}>
                Factura
              </label>
              <input
                type="number"
                id="invoiceCorrelative"
                className={inputClass}
                name="invoiceCorrelative"
                value={itemGang.invoiceCorrelative}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3">
            <div className="relative inline-block w-10 align-middle select-none transition duration-200 ease-in">
              <input
                type="checkbox"
                id="isEnabled"
                name="isEnabled"
                checked={itemGang.isEnabled}
                onChange={handleChangeCheckbox}
                className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 border-gray-300 appearance-none cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
              />
              <label
                htmlFor="isEnabled"
                className={`toggle-label block overflow-hidden h-6 rounded-full cursor-pointer transition-colors ease-in-out duration-200 ${
                  itemGang.isEnabled ? "bg-blue-600" : "bg-gray-300"
                }`}
              ></label>
            </div>
            <span className="text-sm text-gray-700 dark:text-gray-300 font-medium">
              Grupo Activo
            </span>
          </div>
        </div>

        <div className="pt-3">
          <button
            type="submit"
            className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500"
          >
            <i className="fas fa-save mr-2"></i>
            {gang.gangID ? "Actualizar Grupo" : "Registrar Grupo"}
          </button>
        </div>
      </div>
    </form>
  );
}
